import React from 'react';
export const Party = () => (
  <svg width="201px" height="160px" viewBox="0 0 201 160" version="1.1">
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g transform="translate(-766.000000, -737.000000)">
        <path
          d="M914.569827,891 L818.430368,891 L766.50857,838.961239 C765.830477,838.281624 765.830477,837.169606 766.50857,836.489991 L865.267034,737.509056 C865.945999,736.830315 867.054655,736.830315 867.732749,737.509056 L966.492084,836.489991 C967.169305,837.169606 967.169305,838.281624 966.492084,838.961239 L914.569827,891 Z"
          fill="#F3F4F6"
          fillRule="nonzero"
        />
        <path
          d="M816,892 L799,892"
          stroke="#EB1D26"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M878,892 L849,892"
          stroke="#EB1D26"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M794,892 L786,892"
          stroke="#EB1D26"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <g transform="translate(830.000000, 774.000000)">
          <polyline
            fill="#FFFFFF"
            points="13.3912 2.474 5.5962 12.034 0.3992 0.396"
          />
          <polyline
            stroke="#DDE5E8"
            strokeLinecap="round"
            strokeLinejoin="round"
            points="13.3912 2.474 5.5962 12.034 0.3992 0.396"
          />
        </g>
        <g transform="translate(871.000000, 775.000000)">
          <polyline
            fill="#FFFFFF"
            points="0.4678 2.5375 8.6828 12.2825 13.5278 0.9385"
          />
          <polyline
            stroke="#DDE5E8"
            strokeLinecap="round"
            strokeLinejoin="round"
            points="0.4678 2.5375 8.6828 12.2825 13.5278 0.9385"
          />
        </g>
        <path
          d="M805,764 C863.5,793.25 922,764 922,764"
          stroke="#DDE5E8"
          strokeLinecap="round"
        />
        <polyline
          stroke="#DDE5E8"
          strokeLinecap="round"
          strokeLinejoin="round"
          points="811 767 813.093846 780 824 771.960842"
        />
        <polyline
          stroke="#DDE5E8"
          strokeLinecap="round"
          strokeLinejoin="round"
          points="851 778 857.609215 789 864 778.350751"
        />
        <polyline
          stroke="#DDE5E8"
          strokeLinecap="round"
          strokeLinejoin="round"
          points="894 774.310205 903.59774 783 907 771"
        />
        <polygon
          stroke="#D62793"
          strokeLinecap="round"
          strokeLinejoin="round"
          points="847.581837 839 849 832.549993 845.438226 832 845 838.281602"
        />
        <polygon
          stroke="#CCD82B"
          strokeLinecap="round"
          strokeLinejoin="round"
          points="843 809.023333 846.150194 815 849 813.239666 845.271318 808"
        />
        <g transform="translate(821.000000, 843.000000)">
          <path
            d="M26.5352,11.8715 C28.6332,15.6165 28.6932,16.4655 28.6932,16.4655 C28.7712,17.5625 28.0012,18.7985 26.9822,19.2125 L1.9762,29.3565 C0.9562,29.7705 0.3912,29.2505 0.7192,28.1995 L8.7692,2.4425 C9.0982,1.3925 10.2432,0.3285 11.3132,0.0775 C11.3132,0.0775 15.2142,-0.8365 22.4822,6.5285 C23.1172,7.1715 23.6882,7.8125 24.2022,8.4465"
            fill="#FFFFFF"
          />
          <path
            d="M26.5352,11.8715 C28.6332,15.6165 28.6932,16.4655 28.6932,16.4655 C28.7712,17.5625 28.0012,18.7985 26.9822,19.2125 L1.9762,29.3565 C0.9562,29.7705 0.3912,29.2505 0.7192,28.1995 L8.7692,2.4425 C9.0982,1.3925 10.2432,0.3285 11.3132,0.0775 C11.3132,0.0775 15.2142,-0.8365 22.4822,6.5285 C23.1172,7.1715 23.6882,7.8125 24.2022,8.4465"
            stroke="#7350A0"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
        <polyline
          stroke="#F5C400"
          strokeLinecap="round"
          strokeLinejoin="round"
          points="853 853 853.81083 849.119202 856.439554 851.550643 857.652812 847.500939 860.621208 849.78977 861.213891 846 864 848.365699"
        />
        <path
          d="M841,892.999522 C841,895.208727 836.746374,897 831.5,897 C826.253626,897 822,895.208727 822,892.999522 C822,890.790317 826.253626,889 831.5,889 C836.746374,889 841,890.790317 841,892.999522"
          fill="#D0D7DA"
        />
        <path
          d="M902,892.999522 C902,895.208727 897.746374,897 892.5,897 C887.253626,897 883,895.208727 883,892.999522 C883,890.790317 887.253626,889 892.5,889 C897.746374,889 902,890.790317 902,892.999522"
          fill="#D0D7DA"
        />
        <polyline
          stroke="#F5C400"
          strokeLinecap="round"
          strokeLinejoin="round"
          points="836.456899 836 833 833.635161 836.626549 832.247802 833.189479 829.443951 836.832553 827.686898 833.364638 825.559146 837 824"
        />
        <path
          d="M859.99131,833.869392 C860.063418,834.417633 859.678844,834.920091 859.131743,834.991053 C858.583497,835.064304 858.081033,834.679735 858.008926,834.131494 C857.935674,833.584399 858.321392,833.08194 858.868493,833.008689 C859.416739,832.936582 859.919203,833.321152 859.99131,833.869392"
          fill="#0B9CE5"
        />
        <path
          d="M853.991314,819.868269 C854.06339,820.41651 853.678987,820.918968 853.132128,820.991075 C852.584125,821.064326 852.081884,820.678612 852.008664,820.130372 C851.936589,819.583276 852.322136,819.081962 852.868995,819.00871 C853.415854,818.936604 853.919239,819.320029 853.991314,819.868269"
          fill="#D62793"
        />
        <path
          d="M842.10427,850.477628 C845.790308,854.464972 847.836166,858.602745 846.674453,859.720073 C845.512739,860.8374 841.58213,858.509717 837.896092,854.522372 C834.210055,850.535028 832.163227,846.397255 833.32591,845.279927 C834.487624,844.1626 838.418233,846.490283 842.10427,850.477628"
          fill="#DDE5E8"
        />
        <path
          d="M830,852 C832.270927,854.640746 837.233166,860.796343 838,865"
          stroke="#DDE5E8"
          strokeLinecap="round"
        />
        <path
          d="M841,858 C841.848517,859.364238 842.568856,860.738884 843,862"
          stroke="#DDE5E8"
          strokeLinecap="round"
        />
        <path
          d="M827,859 C828.604796,861.487387 830.280609,864.468528 831,867"
          stroke="#DDE5E8"
          strokeLinecap="round"
        />
        <path
          d="M825,867 C825.371813,868.00073 825.714589,869.013504 826,870"
          stroke="#DDE5E8"
          strokeLinecap="round"
        />
        <polygon
          stroke="#F5C400"
          strokeLinecap="round"
          strokeLinejoin="round"
          points="887.548968 794 889 800.427838 885.480543 801 885 794.734388"
        />
        <g transform="translate(874.000000, 833.000000)">
          <path
            d="M3.1832,11.0082 C0.7232,14.5272 0.5782,15.3642 0.5782,15.3642 C0.3912,16.4482 1.0332,17.7552 2.0062,18.2682 L25.8762,30.8562 C26.8502,31.3692 27.4642,30.9072 27.2422,29.8302 L21.8012,3.3992 C21.5792,2.3202 20.5462,1.1482 19.5052,0.7912 C19.5052,0.7912 15.7152,-0.5078 7.7482,6.0962 C7.0532,6.6722 6.4212,7.2542 5.8462,7.8332"
            fill="#FFFFFF"
          />
          <path
            d="M3.1832,11.0082 C0.7232,14.5272 0.5782,15.3642 0.5782,15.3642 C0.3912,16.4482 1.0332,17.7552 2.0062,18.2682 L25.8762,30.8562 C26.8502,31.3692 27.4642,30.9072 27.2422,29.8302 L21.8012,3.3992 C21.5792,2.3202 20.5462,1.1482 19.5052,0.7912 C19.5052,0.7912 15.7152,-0.5078 7.7482,6.0962 C7.0532,6.6722 6.4212,7.2542 5.8462,7.8332"
            stroke="#7350A0"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
        <polyline
          stroke="#D62793"
          strokeLinecap="round"
          strokeLinejoin="round"
          points="876 840 875.924842 836.244194 872.872432 838.027292 872.431506 834.041657 869.07145 835.631314 869.194709 832 866 833.694996"
        />
        <polyline
          stroke="#0B9CE5"
          strokeLinecap="round"
          strokeLinejoin="round"
          points="888 828 891.642886 826.310862 888.630381 824.247265 892.347068 822.119562 889.397089 819.686594 893 818.234546 890.016195 816"
        />
        <path
          d="M876.05685,827.667703 C875.873826,828.189321 876.147218,828.760126 876.668836,828.94315 C877.18931,829.126174 877.760116,828.852782 877.94314,828.331164 C878.126163,827.81069 877.852772,827.239884 877.332297,827.05686 C876.810679,826.873837 876.239874,827.147228 876.05685,827.667703"
          fill="#F5C400"
        />
        <path
          d="M869.05685,805.668836 C868.873825,806.18931 869.147219,806.760116 869.668839,806.94314 C870.189316,807.126163 870.760125,806.852772 870.94315,806.332297 C871.126175,805.810679 870.852781,805.239874 870.331161,805.05685 C869.810684,804.873826 869.239875,805.147218 869.05685,805.668836"
          fill="#CCD82B"
        />
        <path
          d="M881.05688,815.668081 C880.873793,816.18885 881.147279,816.75998 881.667931,816.943107 C882.189727,817.126235 882.759583,816.852688 882.942669,816.331919 C883.1269,815.81115 882.85227,815.24002 882.331619,815.056893 C881.810967,814.873765 881.239966,815.147312 881.05688,815.668081"
          fill="#7350A0"
        />
        <path
          d="M883.001638,840.733506 C878.724622,844.391124 876.151866,848.37008 877.255645,849.621185 C878.359424,850.87229 882.721346,848.923105 886.998362,845.266494 C891.275378,841.608876 893.848134,837.62992 892.744355,836.378815 C891.640576,835.12771 887.278654,837.076895 883.001638,840.733506"
          fill="#DDE5E8"
        />
        <path
          d="M896,843 C893.555505,845.576642 888.171532,851.618779 887,856"
          stroke="#DDE5E8"
          strokeLinecap="round"
        />
        <path
          d="M884,848 C883.181739,849.347934 882.466957,850.719761 882,852"
          stroke="#DDE5E8"
          strokeLinecap="round"
        />
        <path
          d="M898,850 C896.065302,852.447218 894.007797,855.407176 893,858"
          stroke="#DDE5E8"
          strokeLinecap="round"
        />
        <path
          d="M900,858 C899.268176,858.9942 898.585221,860.0058 898,861"
          stroke="#DDE5E8"
          strokeLinecap="round"
        />
        <path
          d="M943,893 L911,893"
          stroke="#EB1D26"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </g>
  </svg>
);
